// extracted by mini-css-extract-plugin
export var iconflexwrapper = "snspostshare-module--iconflexwrapper--81c4a";
export var iconwrapper = "snspostshare-module--iconwrapper--539a2";
export var leadtext = "snspostshare-module--leadtext--f6b71";
export var snspostshare = "snspostshare-module--snspostshare--beadb";